import { Task, Timestamp, WeekDays } from '@griply/types';
import { addMonths } from 'date-fns';

import { getEarliestUncompletedOccurrence } from './get-earliest-uncompleted-occurrence';

export type GetNextOccurrenceDateOptions = {
  today: Timestamp;
  weekStartsOn: WeekDays;
};

// Probed in order, so only long-interval schedules pay for the full horizon.
const horizonMonths = [2, 24];

// Looks past the current timeframe, which `getDueTaskPlanning` cannot — it answers "is this due now".
export const getNextOccurrenceDate = (
  task: Task,
  { today, weekStartsOn }: GetNextOccurrenceDateOptions,
): Timestamp | undefined => {
  if (!task.schedules?.length) {
    return undefined;
  }

  for (const months of horizonMonths) {
    const next = getEarliestUncompletedOccurrence(task, {
      startDate: today,
      endDate: addMonths(today, months),
      today,
      weekStartsOn,
    });

    if (next) {
      return next.date;
    }
  }

  return undefined;
};
